<template>
  <div class="main-cn">
      <div class="main-bd mg20">
            <el-tabs v-model="activeName" @tab-click="handleClick" v-loading="loading">
                <el-tab-pane label="我的客户" name="my-index"></el-tab-pane>
                <el-tab-pane label="我的协作客户" name="my-cooperator"></el-tab-pane>
            </el-tabs>
          <el-row class="searchSection" >
              <SearchForm 
                :params="searcherModel" 
                :fields="fields" 
                :cache_field="customerSearchCacheField" 
                @search="submitSearch" 
                @reset="resetForm" 
                :key="search_form_key"> 
                </SearchForm>
                
          </el-row>
          <el-row class="addBtn" v-if="activeName == 'my-index'">
              <el-button v-if="Acs('/customers/bind')" type="primary" size="small" @click="showBatchBindDialog()" >
                {{title1}}
              </el-button>
              <el-button type="primary" size="small"  v-if="Acs('/sales-leads/query-repeat')"  @click="showQueryRepeat = true">数据查重</el-button>
              <!-- <el-button :disabled="disableBatchOption" type="danger" v-if="Acs('/customers/delete')" size="small" @click="showBatchDeleteDialog()" >批量删除</el-button> -->
              <el-button :disabled="disableBatchOption" type="warning" size="small" v-if="Acs('/customers/unbind') && this.$route.path != '/customers/public' " @click="showBatchUnbindDialog()" >批量解绑</el-button>
              &nbsp;&nbsp;&nbsp;<MyBindList></MyBindList>
          </el-row>
          <el-table :data="customers" style="width: 100%" class="tabTopBorder" v-loading="loading" @sort-change="submitSearch(null, $event)" @selection-change="handleSelectionChange" v-watermask>
                <el-table-column prop="id"  type="selection" width="50"></el-table-column>
                <el-table-column label="客户名称" prop="name" >
                    <template slot-scope="scope">
                        <span class="el-dropdown-link customer-name">
                            <router-link target="_blank" :to="{path: '/customers/view', query: {id: scope.row.id}}">
                                {{scope.row.name}}<br>
                                ({{scope.row.type_memo}}<span v-for="(tag, index) in scope.row.tag" :key="index">/{{tag.tag_name}}</span>)<br>
                            </router-link>
                        </span>
                        <span v-if="scope.row.child > 0">
                            <CustomerChild v-if="isChild" ref="childMerge" :customerId="scope.row.id" :masterName="scope.row.name" :routePath="$route.path" @cancelMerge="handleCancelMerge($event)"></CustomerChild>
                        </span>
                    </template>
                </el-table-column>
                <el-table-column prop="products"  label="申请/已购产品" width="180">
                    <template slot-scope="scope">
                        <div v-if="scope.row.apply_products">
                            【申请】<span style="color: red;">{{scope.row.apply_products}}</span>
                        </div>
                        <div v-if="scope.row.products.length" >
                            <div v-if="scope.row.products.length == 1" class="product-buyed" >
                                <p>【{{scope.row.products[0].order_type_memo}}】{{scope.row.products[0].product_name}}
                                    <span style="color:red;" v-if="scope.row.products[0].expire_day == 0">已到期</span>
                                    <span style="color:green;" v-else-if="scope.row.products[0].expire_day < 10">{{scope.row.products[0].expire_day}}天后到期</span>
                                </p>
                                <p>{{scope.row.products[0].start_at}}~{{scope.row.products[0].end_at}}</p>
                            </div>
                            <el-dropdown v-else  >
                                <span class="el-dropdown-link product-buyed" >
                                    <p>【{{scope.row.products[0].order_type_memo}}】{{scope.row.products[0].product_name}}
                                        <span style="color:red;" v-if="scope.row.products[0].expire_day == 0">已到期</span>
                                        <span style="color:green;" v-else-if="scope.row.products[0].expire_day < 10">{{scope.row.products[0].expire_day}}天后到期</span>
                                    </p>
                                    <p>{{scope.row.products[0].start_at}}~{{scope.row.products[0].end_at}}</p>
                                </span>
                                <el-dropdown-menu slot="dropdown">
                                    <el-dropdown-item v-for="product in _.orderBy(scope.row.products,['end_at','open_state'], ['desc', 'desc'])" :key="product.id" >
                                        <p>【{{product.order_type_memo}}】{{product.product_name}}
                                            <span style="color:red;" v-if="product.expire_day == 0">已到期</span>
                                            <span style="color:green;" v-else-if="product.expire_day < 10">{{product.expire_day}}天后到期</span>
                                        </p>
                                        <p>{{product.start_at}}~{{product.end_at}}</p>
                                    </el-dropdown-item>
                                </el-dropdown-menu>
                            </el-dropdown>
                        </div>
                    </template>
                </el-table-column>
                <el-table-column prop="level_name" scoped-slot width="80">
                    <template slot="header" slot-scope="scope">
                        级别
                        <el-tooltip placement="right">
                            <div slot="content">
                                    A:意向极高的客户<br />
                                    B:试用中客户，到期自动掉至C级<br />
                                    C:试用结束客户与其他客户<br />
                                    D:正式客户，全部产品到期自动掉至E级<br />
                                    E:断续客户<br />
                                </div>
                            <i class="el-icon-info"></i>
                        </el-tooltip>
                    </template>
                </el-table-column>
                <el-table-column prop="last_trace_created_at" sortable="last_trace_created_at" label="最后跟进时间" width="150">
                    <template slot-scope="scope">
                        <el-tooltip v-if="scope.row.lastTrace" effect="light" :content="scope.row.lastTrace.content" placement="top">
                            <router-link :to="{ path: '/customers/view', query: {id: scope.row.id}}" style="color: #409EFF" >
                                {{scope.row.lastTrace.created_at}}
                            </router-link>
                        </el-tooltip>
                    </template>
                </el-table-column>
                <el-table-column prop="next_time" sortable="next_time" label="下次跟进时间" width="150">
                    <template slot-scope="scope">
                        <span v-if="scope.row.lastTrace">
                            {{scope.row.lastTrace.next_time}}
                        </span>
                    </template>
                </el-table-column>
                <el-table-column prop="bind_at" sortable="bind_at" label="绑定客户时间" width="150">
                    <template slot-scope="scope">
                        <span v-if="scope.row.bind_at">
                            {{scope.row.bind_at}}
                        </span>
                    </template>
                </el-table-column>
             <el-table-column prop="district_names" label="所在地区">
                 <template slot-scope="scope">
                      <i v-if="scope.row.is_Lock == 1"
                         class="el-icon-lock"
                         style="color: rgb(239 6 6); margin-left: 5px; font-size: 12px;">
                      </i>
                     <span>{{ scope.row.district_names }}</span>

                 </template>
             </el-table-column>
                <el-table-column prop="user_name" label="业务员" width="120">
                    <template slot-scope="scope">
                        <el-button v-if="!scope.row.user_id" @click="showBindDialog(scope.row)" type="success" size="small" :disabled="disabled">绑定</el-button>
                        <span v-else-if="scope.row.user_id == $store.getters.userId" ><!--@TODU-->
                            <img :src="user_avatar" style="border:0px;border-radius:10px;-webkit-border-radius:10px;">
                            <el-button  @click="showUnbindDialog(scope.row)" v-if="Acs('/customers/unbind')" type="text"
                                        size="medium" style="color: #F56C6C;font-weight: 900" class="el-icon-close">
                            </el-button>
                        </span>
                        <span v-else >
                            {{scope.row.user_name}}
                            <el-button  @click="showUnbindDialog(scope.row)" v-if="Acs('/customers/unbind')" type="text"
                                    size="medium" style="color: #F56C6C;font-weight: 900" class="el-icon-close">
                            </el-button>
                        </span>
                        <div v-for="(cooperator, index) in scope.row.cooperator" :key="index">
                                {{cooperator.user_name}}（协作）<el-button  @click="deleteCooperator(cooperator)" v-if="Acs('/customer-cooperator/delete')" type="text"
                                    size="mini" style="color: #F56C6C;font-weight: 900" class="el-icon-close">
                                </el-button>
                            </div>
                    </template>
                </el-table-column>
                <el-table-column label="操作" fixed="right">
                    <template slot-scope="scope">
                        <el-button @click="handleView(scope.row)" type="text"  size="small">查看</el-button>
                        <el-button v-if="scope.row.my_customer" @click="handleUpdateMyCustomer(scope.row)" type="text" size="small">编辑</el-button>
                        <el-button v-if="scope.row.all_customer" @click="handleUpdate(scope.row)" type="text" size="small">编辑</el-button>
                        <el-button type="text" size="small" @click="showDeleteDialog(scope.row)" v-if="scope.row.can_delete" >删除</el-button>
                    </template>
                </el-table-column>
          </el-table>
          <el-row v-if="linkPage">
              <pagination :linkPage="linkPage" :pageSizes="[10, 20, 30, 50, 100]"></pagination>
          </el-row>

          <!--跟进组件-->
          <trace-modal
              :show-dialog="showTraceModal"
              :customer-id="currentRow.id"
              @closeModal="closeModal"
          >
          </trace-modal>

          <!-- 回访组件 -->
          <visit-modal
              :show-dialog="showVisitModal"
              :customer-id="currentRow.id"
              @closeModal="closeModal"
          >
          </visit-modal>


          <el-dialog :title="dialogTitle" :visible.sync="dialogFormVisible">
              <el-form :model="form">
                  <el-form-item label="业务员姓名">
                      <UserSelect1 v-model="form.user_id" @change="UserHandleChange"></UserSelect1>
                  </el-form-item>
              </el-form>

              <div slot="footer" class="dialog-footer">
                  <el-button @click="dialogFormVisible = false">取 消</el-button>
                  <el-button type="primary" @click="handleBind()" :loading="loading">确 定</el-button>
              </div>
          </el-dialog>
      </div>
      <!-- 线索查重 -->
      <query-repeat v-if="showQueryRepeat" :display="showQueryRepeat" @watchQueryRepeatClose="watchQueryRepeatClose"></query-repeat>
  </div>
</template>

<script>
  import Pagination from "~/widgets/Pagination.vue";
  import CustomerService from "~/services/customer";
  import TraceModal from "~/views/tasks/TraceModal.vue";
  import VisitModal from "~/views/tasks/VisitModal.vue";
  import UserSelect1 from "~/widgets/UserSelectCorp.vue";
  import UserSelect from "~/widgets/UserSelect.vue";
  import user_avatar from '~/assets/usre-icon.png';
  import CommonService from "~/services/common";
  import QueryRepeat from "~/views/clue/dialog/QueryRepeat.vue";
  import CustomerChild from "~/widgets/CustomerChild.vue";
  import SearchForm from "~/widgets/SearchForm.vue";
  import MyBindList from "~/views/customer/dialog/MyBindList.vue";
  
export default {
    components: {
        UserSelect1,
        Pagination,
        TraceModal,
        VisitModal,
        QueryRepeat,
        CustomerChild,
        UserSelect,
        SearchForm,
        MyBindList
    },
    data() {
        return {
            user_avatar,
            searcherModel: {},
            customers: [],
            showQueryRepeat:false,
            loading: true,
            // 分页信息
            linkPage: null,
            // 当前被点击处理的表格行记录
            currentRow: {},
            showTraceModal: false,
            showVisitModal: false,
            //客户绑定，删除
            form: {
                customer_ids: [],
                user_id: '',
            },
            dialogFormVisible: false,
            dialogTitle: '',
            title1: '转交给指定业务员',
            //全选，全不选
            multipleSelection: [],
            disabled: false,
            activeName: 'my-index',
            // 是否禁用批量操作状态，它的状态依赖于 multipleSelection 中是否有被选中的记录
            disableBatchOption : true,
            search_form_key: 0,
            fields: [],
            isChild: true,
        };
    },

        // 监听路由参数更新执行分页请求
        beforeRouteUpdate: function (to, from, next) {
            this.searcherModel['page'] = to.query["page"];
            this.searcherModel['perPage'] = to.query["perPage"];
            this.submitSearch();
        },

        created: function () {
            this.resetForm();
            this.dialogTitle = this.title1

            if(!this.Acs('/customers/bind')) {
                this.disabled = true;
                return;
            }
        },

        computed: {
            customerSearchCacheField() {
                return 'search_customer_config_' + this.activeName + '_' + this.$route.path + '_v2';
            }
        },

        //监听$route, 路由有变化时，重载列表。
        watch: {
            $route: function (value, oldValue) {
                this.dialogTitle = this.title1;
                this.resetForm();
            },
            'searcherModel.product_type':function (val) {
                if(val){
                    //加载产品列表
                    CommonService.getProducts({
                        is_deleted: 0,
                        fields: 'id,name,price,code'
                    }).then(res => {
                        this.products = res.data
                    });
                }
            },
            multipleSelection: function (value, oldValue) {
                if (value.length > 0) {
                    this.disableBatchOption = false;
                } else {
                    this.disableBatchOption = true;
                }
            },
        },
        destroyed(){
            delete localStorage['/customers/my-index'+this.$store.getters.token];
        },
        methods: {
            watchQueryRepeatClose() {
                this.showQueryRepeat = false;
            },
            // 客户列表展示
            initListData(params = {}) {
                if(this.$route.query['tab']){
                    params['tab'] = this.$route.query['tab'];
                }
                // loading 动画
                this.loading = true;
                let can_delete = true;
                let all_customer = true;
                let my_customer = true;
                let dtd;
                if (this.$route.path == '/customers/index') {
                    dtd = CustomerService.getList(params);
                    my_customer = false;
                }else {
                    params['active_name'] = this.activeName;
                    //我的客户
                    dtd = CustomerService.getMyList(params);
                    can_delete = false;
                    all_customer = false;
                }
                dtd.then(res => {
                    this.customers =  _.map(res.data, (item) => {
                        item.can_delete = can_delete;
                        item.all_customer = all_customer;
                        item.my_customer = my_customer;
                        return item;
                    });
                    if (res._meta) {
                        this.linkPage = res._meta;
                    }
                    this.loading = false;
                })

            },

            // 筛选查询
            submitSearch(params = null, $data = null) {
                if($data && typeof $data.order !== undefined){
                    this.searcherModel.sort_name = $data['prop'];
                    this.searcherModel.sort_by = $data['order'];
                }
                if(params){
                    this.searcherModel = params;
                }
                params = _.clone(this.searcherModel);
                _.each(params, (val, key) => {
                    // 如果值是假值，除了数字 0 和字符串 '0'，都删除该键
                    if (val === undefined || val === null || (typeof val === 'string' && val === '')) {
                        delete params[key];
                    }
                })
                this.initListData(params);
            },

            // 重置筛选表单
            resetForm() {
                this.searcherModel = {
                    name: '',
                    type: '',
                    province_id: 0,
                    city_id: 0,
                    district_id: 0,
                    product_id: '',
                    level: '',
                    product_type:'',
                    sort_name:'',
                    sort_by:'',
                    stop_renew: '',
                    is_mobile: '',
                    stages: [],
                    repay_type: 0,
                    time_type: 1,
                    time_status: "",
                    is_overtime: '',
                    cooperator_id: '',
                    is_mobile: '',
                    formal_status: '',
                    create_times: [],
                    traceTimes: [],
                    nextTimes: [],
                    product_times: [],
                };
                this.products = [];
                this.fields = CustomerService.getFields(this.$route.path, this.searcherModel.active_name);
                this.search_form_key ++;

                this.submitSearch();
            },

            handleView(customer) {
                let routeData = this.$router.resolve({
                    path: "/customers/view",
                    query: { id: customer.id },
                });
                window.open(routeData.href, '_blank');
            },

            handleUpdate(customer) {
                let routeData = this.$router.resolve({
                    path: "/customers/update",
                    query: { id: customer.id,referer: this.$route.path },
                });
                window.open(routeData.href, '_blank');
            },

            handleUpdateMyCustomer(customer) {

                let path = "";

                if (this.Acs('/customers/index')) {
                    path = '/customers/update';
                } else {
                    path = "/customers/my-update";
                }

                let routeData = this.$router.resolve({
                    path: path,
                    query: { id: customer.id },
                });
                window.open(routeData.href, '_blank');
            },

            //展示绑定客户对话框
            showBindDialog(customer) {
                this.dialogFormVisible = true;
                this.form.customer_ids = [];
                this.form.customer_ids.push(customer.id);
            },

            //展示批量绑定客户对话框
            showBatchBindDialog() {
                let t = this.resDialog();
                if (!t) return false;
                this.dialogFormVisible = true;
                this.form.customer_ids = [];
                this.form.customer_ids = this.multipleSelection;
            },

            //绑定客户
            handleBind() {
                this.loading = true;
                CustomerService.bind(this.form).then(res => {
                    let form = this.form;
                    this.resp_alert(res, '绑定成功', res => {
                        this.customers.map(function(customer, index) {
                        form.customer_ids.map(function(customer_id, index){
                            if (customer.id == customer_id) {
                            customer.user_id = form.user_id;
                                    customer.username = res.data.username;
                            }
                            });
                        });
                    });
                    this.loading = false;
                    this.submitSearch();
                }).catch(() => {
                    this.loading = false;
                });
                this.dialogFormVisible = false;
            },

            // 通用提示
            resDialog() {
                if (this.multipleSelection.length <= 0) {
                    this.$message({
                        message: '对不起，请先选择要操作的客户数据',
                        type: 'error'
                    });
                    return false;
                }
                return true;
            },

            confirm(){
                return this.$confirm("此操作是解绑操作, 是否继续?", "提示", {
                    confirmButtonText: "确定",
                    cancelButtonText: "取消",
                    type: "warning",
                    center: true
                });
            },

            //删除客户的提示和数据处理。
            showDeleteDialog(customer) {
                this.confirm().then(() => {
                    this.form.customer_ids = [];
                    this.form.customer_ids.push(customer.id);
                    this.handleDelete();

                }).catch(() => {});
            },

            //展示批量删除客户对话框
            showBatchDeleteDialog() {
                let t = this.resDialog();
                if (!t) return false;
                this.form.customer_ids = [];
                this.form.customer_ids = this.multipleSelection;
                this.handleDelete();
            },

            //解绑客户的提示和数据处理。
            showUnbindDialog(customer) {
                this.$confirm("您确定要解绑该客户吗？解绑后，客户将会进入客户公海池被其他人绑定哦", "提示", {
                    confirmButtonText: "确定",
                    cancelButtonText: "取消",
                    type: "warning",
                    center: true
                }).then(() => {
                    this.form.customer_ids = [];
                    this.form.customer_ids.push(customer.id);
                    this.handleUnbind();
                }).catch(() => {});
            },


            //批量解绑客户的提示和数据处理。
            showBatchUnbindDialog(customer) {
                let t = this.resDialog();
                if (!t) return false;
                this.$confirm("您确定要解绑选中客户吗？解绑后，客户将会进入客户公海池被其他人绑定哦", "提示", {
                    confirmButtonText: "确定",
                    cancelButtonText: "取消",
                    type: "warning",
                    center: true
                }).then(() =>{
                    this.form.customer_ids = [];
                    this.form.customer_ids = this.multipleSelection;
                    this.handleUnbind();
                });

            },

            //解绑客户
            handleUnbind() {
                CustomerService.unbind({'customer_ids':this.form.customer_ids}).then(res => {
                    let form = this.form;
                    this.resp_alert(res, '解绑成功', res => {
                        this.customers = this.customers.filter(customer => {
                            let item = form.customer_ids.find(customer_id => {
                                return customer.id == customer_id;
                            });
                            return !item;
                        });
                    });
                });
            },

            //删除客户
            handleDelete() {
                CustomerService.delete(this.form.customer_ids).then(res => {
                    let form = this.form;
                    this.resp_alert(res, '删除成功', res => {
                        form.customer_ids.forEach(customer_id => {
                            this.customers = this.customers.filter( customer => {
                                return customer_id != customer.id;
                            })
                        });
                    });
                })
            },

            // 监听对话框关闭事件
            closeModal(isShow) {
                this.showTraceModal = isShow;
                this.showVisitModal = isShow;
                //this.isFinished = isShow;
                this.submitSearch();
            },

            //业务员姓名远程搜索组件赋值
            UserHandleChange(value) {
                this.form.user_id = value;
            },


            //全选，全不选
            handleSelectionChange(customers) {
                this.multipleSelection = [];
                customers.forEach(row => {
                    this.multipleSelection.push(row.id);
                });
            },

            //取消合并
            handleCancelMerge(value) {
                this.submitSearch();
            },

            handleClick() {
                this.resetForm();
            },

            deleteCooperator(obj){
                this.$confirm("确定要解除协作人吗？", "提示", {
                    confirmButtonText: "确定",
                    cancelButtonText: "取消",
                    type: "warning",
                    center: true
                }).then(() => {
                    CustomerCooperatorService.delete(obj.id).then(res => {
                        if(res && res.code == 0){
                            this.resp_alert(res, '操作成功', res => {
                                this.customers.map(function(customer, index) {
                                    if(obj.customer_id == customer.id){
                                        customer.cooperator = customer.cooperator.filter(function(item, key){
                                            return item.id != obj.id;
                                        });
                                    }
                                });
                            });
                        }else{
                            this.$message({
                                message: res.msg,
                                type: 'error'
                            });
                        }
                    }).catch((err) => {
                        console.error(err);
                    });
                })
            },

        }
  };
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
  .customer-name {
      cursor: pointer;
  }

  .customer-name:hover {
      color: #409EFF;
  }
</style>



// WEBPACK FOOTER //
// src/views/customer/my-customer.vue